import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { modifyPct } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifyCandleMagnitude/modifyPct';
import { modifyStop } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifyCandleMagnitude/modifyStop';
import { modifyTarget } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifyCandleMagnitude/modifyTarget';
import { modifySoftOrderWithPreviousValue } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { CancelOrderButton } from '../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { EditableTableField } from '../../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import style from './CandleMagnitudeTacticPanel.module.css';

export const CandleMagnitudeTargetRows = observer(({ softOrderId, tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const softOrder = tradePlanStore.softOrdersById[softOrderId] ?? null;
  const targets = softOrder?.value.tacticValue.targets ?? null;

  const removeTarget = (target) => {
    modifySoftOrderWithPreviousValue({
      softOrder,
      type: 'removeTarget',
      previousValue: null,
      value: { target },
    });
  };

  const addTarget = ({ target, pctOfPosition }) => {
    modifySoftOrderWithPreviousValue({
      softOrder,
      type: 'addTarget',
      previousValue: null,
      value: {
        target,
        pctOfPosition: pctOfPosition / 100,
      },
    });
  };
  const modifyMagTarget = (prevValue, newValue) => {
    modifyTarget(tradePlanId, softOrderId, prevValue, newValue);
  };

  const modifyPctQty = (target, pctValue) => {
    modifyPct(tradePlanId, softOrderId, target, pctValue);
  };

  const [addTargetValue, setAddTargetValue] = useState(0);
  const [addPctValue, setAddPctValue] = useState(0);

  if (!softOrder) {
    return null;
  }
  return (
    <tbody>
      {targets.map(({ key, target, pctOfPosition }, index) => {
        return (
          <tr key={key}>
            <td className={style.labelTd}>
              <Body3
                fontWeight={700}
                color={index === 0 ? colors.green : colors.lightGrey}
              >
                {index === 0 ? 'Current' : `${index}`}
              </Body3>
            </td>
            <td className={style.inputTd}>
              <div className={style.inputWrapper}>
                <EditableTableField
                  inputType="number"
                  bodySize={3}
                  initialValue={target}
                  updateValue={(newValue) => modifyMagTarget(target, newValue)}
                  color={colors.lightGrey}
                  backgroundColor="inherit"
                />
              </div>
            </td>
            <td className={style.inputTd}>
              <div className={style.inputWrapper}>
                <EditableTableField
                  inputType="number"
                  bodySize={3}
                  initialValue={Number(pctOfPosition) * 100}
                  updateValue={(newValue) => modifyPctQty(target, newValue / 100)}
                  color={colors.lightGrey}
                  backgroundColor="inherit"
                />
              </div>
            </td>
            <td className={style.inputTd}>
              <div className={style.inputWrapper}>
                <CancelOrderButton
                  width={15}
                  clickHandler={() => {
                    removeTarget(target);
                  }}
                />
              </div>
            </td>
          </tr>
        );
      })}
      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Add
          </Body3>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            <Body3
              fontWeight={700}
              color={colors.lightGrey}
              margin="3px 3px 0 0"
            >
              $
            </Body3>
            <EditableTableFieldNoOnBlurUpdate
              inputType="number"
              fontSize="0.694rem"
              value={addTargetValue}
              setValue={(value) => setAddTargetValue(value)}
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
          </div>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            <EditableTableFieldNoOnBlurUpdate
              inputType="number"
              fontSize="0.694rem"
              value={addPctValue}
              setValue={(value) => setAddPctValue(value)}
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
            <Body3
              fontWeight={700}
              color={colors.lightGrey}
              margin="3px 3px 0 0"
            >
              %
            </Body3>
          </div>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            <IncrementButton
              paddingPercent={10}
              color={colors.white}
              backgroundColor={colors.blue}
              width={15}
              stroke={2}
              handleClick={() => {
                addTarget({
                  target: addTargetValue,
                  pctOfPosition: addPctValue,
                });
              }}
            />
          </div>
        </td>
      </tr>
    </tbody>
  );
});

CandleMagnitudeTargetRows.propTypes = {
  targets: PropTypes.array,
};

export const CandleMagnitudeStopRows = observer(
  ({ softOrderId, direction, tradePlanId }) => {
    const { tradePlanStore } = useWebsocketStore();
    const softOrder = tradePlanStore.softOrdersById[softOrderId] ?? null;
    const stops = softOrder?.value.tacticValue.stops ?? null;
    const targets = softOrder?.value.tacticValue.targets ?? null;
    const addStop = (stop) => {
      modifySoftOrderWithPreviousValue({
        softOrder,
        type: 'addStop',
        previousValue: null,
        value: { stop },
      });
    };

    const removeStop = (stop) => {
      modifySoftOrderWithPreviousValue({
        softOrder,
        type: 'removeStop',
        previousValue: null,
        value: { stop },
      });
    };
    const modifyMagStop = (prevValue, newValue) => {
      modifyStop(tradePlanId, softOrderId, prevValue, newValue);
    };

    const [addStopValue, setAddStopValue] = useState(0);


    if (!softOrder) return null;
    return (
      <tbody>
        {stops.map(({ key, stop }, index) => {
          let backgroundColor = 'all';
          if (
            direction === 'long' &&
            stop < 1000000 &&
            stop > 0 &&
            stop >= targets[index - 1]?.target
          )
            backgroundColor = colors.red;
          if (
            direction === 'short' &&
            stop < 1000000 &&
            stop > 0 &&
            stop <= targets[index - 1]?.target
          )
            backgroundColor = colors.red;
          return (
            <tr
              key={key}
              style={{
                backgroundColor,
              }}
            >
              <td className={style.labelTd}>
                <Body3
                  fontWeight={700}
                  color={index === 0 ? colors.red : colors.lightGrey}
                >
                  {index === 0 ? 'Current' : `${index}`}
                </Body3>
              </td>
              <td className={style.inputTd}>
                <div className={style.inputWrapper}>
                  <EditableTableField
                    inputType="number"
                    bodySize={3}
                    initialValue={stop || ''}
                    updateValue={(newValue) => modifyMagStop(stop, newValue)}
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </div>
              </td>
              <td className={style.inputTd}>
                <div className={style.inputWrapper}>
                  <CancelOrderButton
                    width={15}
                    clickHandler={() => {
                      removeStop(stop);
                    }}
                  />
                </div>
              </td>
            </tr>
          );
        })}

        <tr>
          <td className={style.labelTd}>
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Add
            </Body3>
          </td>
          <td className={style.inputTd}>
            <div className={style.inputWrapper}>
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                $
              </Body3>
              <EditableTableFieldNoOnBlurUpdate
                inputType="number"
                fontSize="0.694rem"
                value={addStopValue}
                setValue={(value) => setAddStopValue(value)}
                color={colors.lightGrey}
                backgroundColor="inherit"
              />
            </div>
          </td>
          <td className={style.inputTd}>
            <div className={style.inputWrapper}>
              <IncrementButton
                paddingPercent={10}
                color={colors.white}
                backgroundColor={colors.blue}
                width={15}
                stroke={2}
                handleClick={() => {
                  addStop(addStopValue);
                }}
              />
            </div>
          </td>
        </tr>
      </tbody>
    );
  }
);

CandleMagnitudeStopRows.propTypes = {
  stops: PropTypes.array,
};
